import { render, staticRenderFns } from "./Emojis.vue?vue&type=template&id=b825d506&scoped=true"
import script from "./Emojis.vue?vue&type=script&lang=js"
export * from "./Emojis.vue?vue&type=script&lang=js"
import style0 from "./Emojis.vue?vue&type=style&index=0&id=b825d506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b825d506",
  null
  
)

export default component.exports